<template>
    <div>
        <div v-if="$parent.is_can_update_field(field_name)"
            class="ui small labeled input"
            :class="{fluid: is_fluid}">
            <label class="ui label">{{ $t("models.attributes.core_waybills."+field_name) }}</label>
            <input
                type="text"
                v-if="input_type == 'text'"
                v-model="core_waybill[field_name]">
            <input
                type="number"
                v-if="input_type == 'number'"
                v-model="core_waybill[field_name]">
            <input
                type="email"
                v-else-if="input_type == 'email'"
                v-model="core_waybill[field_name]">
            <input
                type="tel"
                v-else-if="input_type == 'tel'"
                v-model="core_waybill[field_name]">
        </div>

        <div
            v-else
            class="ui basic segment"
            :class="{
                hide_content: !is_dont_hide_content,
                hidden_border: is_hidden_segment_border,
            }"
        >
            {{ $t("models.attributes.core_waybills."+field_name) + '：'}}
            <span v-if="core_waybill[field_name]">
                {{ core_waybill[field_name] }}
            </span>
            <span v-else>
                {{ input_type == 'number' ? 0 : $t('ui.general.no_data') }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        field_name: {
            default: "",
            type: String
        },
        input_type: {
            default: "text",
            type: String
        },
        is_dont_hide_content: {
            default: false,
            type: Boolean
        },
        is_fluid: {
            default: false,
            type: Boolean
        },
        is_hidden_segment_border: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
    .basic.segment {
        & {
            padding: 6px 12px;
            margin: 0;
            width: 100%;

        }
        &.hidden_border {
            border: none;
        }
        &.hide_content {
            height: 30px;
            white-space : nowrap;
            text-overflow : ellipsis;
            overflow: hidden;
        }
    }
</style>
